import { FC } from 'react';
import { world } from '../../../languages';
import { AVAILABLE_WORLDS } from '../../../languages/constants';
import cn from '../../../utils/classnames';
import FontAwesomeIcon from '../../../ui/font-awesome-icon/font-awesome-icon';
import Icon from '../../icon/icon';
import withMobileSize from '../../mobile-size/mobile-size';
import './interactive-badge.scss';

type InteractiveBadgeProps = {
    mobile: boolean;
    width?: number;
    isStandalone?: boolean;
};

const InteractiveBadge: FC<InteractiveBadgeProps> = ({ mobile, isStandalone = false, width }) => {
    if (world === AVAILABLE_WORLDS.DE) {
        return null;
    }

    const isTooSmall = width !== undefined && width < 150;
    const isStandaloneBadge = isStandalone && !isTooSmall;

    if (isStandaloneBadge) {
        const badgeWidth = (width || 0) - (width || 0) * 0.18;
        const onNotEmpty = (v: string | number) => (width === undefined ? undefined : v);

        return (
            <div
                className={cn('interactive-badge-standalone', {
                    sm: mobile,
                    auto: width === undefined
                })}
            >
                <FontAwesomeIcon
                    name='interactive-logo-compact'
                    width={onNotEmpty(badgeWidth - 45)}
                    height={onNotEmpty(badgeWidth / 6) as number}
                    theme='white'
                />
            </div>
        );
    }

    return (
        <div
            className={cn('interactive-badge', {
                md: !mobile,
                sm: mobile,
                purple: isTooSmall && isStandalone
            })}
        >
            <Icon animated={false} name='interactive' />
        </div>
    );
};

export default withMobileSize(InteractiveBadge);
